/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![HandRequestSpeakIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACKklEQVR4nM2Vu4sTcRDH4wvFJyKComAtaKnFIaYK7GV3Hj/ll5lNPA6uCIgWVmIhBBTEawRR4UAQCxEFFQXhrDwff4GFYqndFadBUBEfnPyyj+yZxGRXQQcGMrthPjPfmd9vS6X/wRBxQ8AyXp6cXONia+0KZJ0ikrG/AgCWe8i6iKSXXByQTHRilo/lcnnlHwOQZT4CyM0IqLdiwLyLq9ZuA5KLhTry/frmKFnHz7dareVAshAD7sQdzrgYWJ/mBhDJWAIAlqPM4f40Jj3h5gIs7fj9hdwAZJ1KOzDqI+vpJA5MbR+whul7rB0sAJDpJIFvanuQ5Hky4GazuQpYHkXdyMKwgS+rVI6s6wGQ3k8AxjR2AsnXWO/Hvm93AOn3OL5mTGM7kswC6cme7MA6ByQ/gPSGtXZT5vnrWN92QCFnBn4GWU515VEEksvZ7foV8Cz9M8kTty2e561G1m/dpPI+HbBRL4E7uaqH6ruA9HNczEwPIODwQKa6RTS1Rkfz7LOsk8x2f+tdIDmbxET1vX2HACQPM9W+cFoOBCyF3QbSd/Es5gZvDCqOlJAHe0Dh4YGAIAjWIuunoslhhFV1x/5B4Q5Irv82ec/J5ZyOaoYCmCe2IOuX3PKwtJ3EQwGxTFcLyHOuNKp51m5F1rejV68vrbXrRwZEUsluJHkzfHP0lTvFpSIWfWzkSnIFLHX54G7a3JX3M89rbCQKq8ByHI0eA6OVfjfvP7GfoPsI2uRam5IAAAAASUVORK5CYII=)
 */
export const HandRequestSpeakIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16.02 3.06a1.23 1.23 0 0 0-2.39-.6l-2.14 7.76-.61-.24.83-6.97a1.26 1.26 0 0 0-2.49-.34L8.13 9.65l-.47 2.86a.42.42 0 0 1-.8.1l-.66-1.47a3.92 3.92 0 0 0-1.85-1.9l-.32-.17a1.53 1.53 0 0 0-1.91.47.61.61 0 0 0-.05.65l1.33 2.5c.06.12.12.24.16.37l1.26 4.11a7.47 7.47 0 0 0 14.28.03l.95-3.05 1.85-4.36a1.19 1.19 0 0 0-2.17-.96l-1.8 3.87-.56-.22 2.4-7.64a1.17 1.17 0 0 0-2.21-.75l-2.78 7.4-.67-.26 1.9-8.17Z"
        className={colorClass}
      />
    </svg>
  );
};
